import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./CalenderDateIcon.module.css";
import { useMemo } from "react";

/**
 * View component to display months and days
 */
export function CalenderDateIcon({ years, months, days }) {
  // turning the days array into a single string with ", " and  " & " in between
  const length = days.length;
  var daysString = "";
  for (var i = 0; i < length; i++) {
    daysString += days[i];

    if (i < length - 1) {
      if (length > 2) {
        if (i == length - 2) {
          daysString += " & ";
        } else {
          daysString += ", ";
        }
      } else if (length > 1) {
        daysString += " & ";
      }
    }
  }

  const monthText = useMemo(() => {
    if(months){
      if (months.length > 1) {
        if (months[0] === months[1]) return months[0];
        return `${months[0].substring(0, 3)} - ${months[1].substring(0, 3)}`;
      }
      return months[0];
    }
    return ""
  }, [months]);
  const yearText = useMemo(() => {
    if(years){
      if (years.length > 1) {
        if (years[0] === years[1]) return years[0];
        return `${years[0]} - ${years[1]}`;
      }
      return years[0];
    }
    return ""
  }, [years]);

  return (
    <div className={classNames(styles.calendar_date_icon_container)}>
      <div className={classNames(styles.monthText)}>
        {monthText}
        <div
          className={classNames(
            styles.yearText,
            years.length > 1 && years[0] !== years[1] ? styles.twoYearText : ""
          )}
        >
          <p>{yearText}</p>
        </div>
      </div>
      <div
        className={classNames(
          styles.dayText,
          days.length <= 1 ? styles.bigDateFont : styles.smallDateFont // using smaller font if there are more than 1 days
        )}
      >
        {daysString}
      </div>
    </div>
  );
}

CalenderDateIcon.propTypes = {
  years: PropTypes.arrayOf(PropTypes.string).isRequired,
  months: PropTypes.arrayOf(PropTypes.string).isRequired,
  days: PropTypes.arrayOf(PropTypes.string).isRequired,
};
